import { z } from 'zod';

/**
 * Common Enums
 * Platform-wide enumerations used across different domains
 */

// Log Level Enum
export const LogLevelSchema = z.enum(['error', 'warn', 'info', 'http', 'debug', 'verbose'], {
  error: "Invalid log level"
});

// Notification Type Enum
export const NotificationTypeSchema = z.enum(['email', 'sms', 'push', 'slack'], {
  error: "Invalid notification type"
});

// Sort Order Enum
export const SortOrderSchema = z.enum(['asc', 'desc'], {
  error: "Sort order must be 'asc' or 'desc'"
});

// Job Type Enum
export const JobTypeSchema = z.enum([
  'TEXT_TO_IMAGE',
  'IMAGE_TO_IMAGE', 
  'IMAGE_UPSCALE',
  'VIDEO_GENERATION',
  'AUDIO_GENERATION',
  'TEXT_GENERATION',
  'IMAGE_ANALYSIS',
  'CUSTOM_TOOL',
  'WEBHOOK'
], {
  error: "Invalid job type"
});

// Job Status Enum
export const JobStatusSchema = z.enum(['PENDING', 'RUNNING', 'COMPLETED', 'FAILED', 'CANCELED'], {
  error: "Invalid job status"
});

// Export TypeScript types
export type LogLevel = z.infer<typeof LogLevelSchema>;
export type NotificationType = z.infer<typeof NotificationTypeSchema>;
export type SortOrder = z.infer<typeof SortOrderSchema>;
export type JobType = z.infer<typeof JobTypeSchema>;
export type JobStatus = z.infer<typeof JobStatusSchema>;